import React from "react";
import "./Badge.css";

// Badge — supporte deux API :
//  • moderne (utilisée partout dans l'admin) : <Badge variant="success">{texte}</Badge>
//  • héritée : <Badge type="success" label="texte" />
// Accepte aussi un `count` optionnel affiché après le contenu :
//   <Badge variant="info" count={12}>Trajets</Badge>
const Badge = ({ label, type, variant, count, children, className = "" }) => {
  const kind = variant || type || "default";
  const content = (children !== undefined && children !== null && children !== "")
    ? children
    : label;
  return (
    <span className={`ui-badge ${kind} ${className}`.trim()}>
      {content}
      {count !== undefined && count !== null && (
        <span className="ui-badge-count">{content ? " " : ""}{count}</span>
      )}
    </span>
  );
};

export default Badge;
